import { GetterTree } from "vuex"
import { AvailabilityResource, AvailabilitiesState } from "~/store/availabilities/availabilities.types"
import { RootState } from "~/store/store.types"
import { getResource } from "~/utils/store"

export const getters: GetterTree<AvailabilitiesState, RootState> = {
  resourceById (state, _, __, rootGetters) {
    return (id: string, included: string | string[] = []) =>
      getResource<AvailabilityResource>(state, id, rootGetters, included)
  }
}


export default getters
